export const namespace = 'authentication' as const
export const name = 'authenticationWixCodeSdk' as const

export const dialogFeatureName = 'captchaDialog' as const
export const CaptchaDialogApiSymbol = Symbol('CaptchaDialogApi')
export const DIALOG_COMPONENT_ID = 'CAPTCHA_DIALOG_ROOT_COMP' as const
